import { createFileRoute } from '@tanstack/react-router';
import { SEO } from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { NotFoundComponent } from './components/NotFound';
import messages from './messages';

export const Route = createFileRoute('/_authenticated/not-found')({
  component: NotFound,
});

function NotFound() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const notFoundMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={notFoundMessages.title}
        description={notFoundMessages.description}
        keywords={notFoundMessages.keywords}
        page="/not-found"
      />
      <div className="px-6 py-4">
        <NotFoundComponent />
      </div>
    </>
  );
}

export default NotFound;
